import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { useTranslation } from "react-i18next";
import Constants from "../../../../common/Constants";
import MasterList from "../../../common/MasterList";
import ModalBody from "../../../common/ModalBody";
import ModalHeader from "../../../common/ModalHeader";
import { useSelector, useDispatch } from "react-redux";
import { toastFunc } from "../../../../components/common/util";
import {
  addMasterRecord,
  fetchMasterListById,
} from "../../../../redux/feature/manufacturing_app/commonMasterListSlice";
import { ConfirmationModal } from "../../../common/ConfirmationModal";
import { ErrorModal } from "../../../common/errorModal";
import ProcessModal from "./ProcessForm";
import { AlertModal } from "../../../common/AlertModal";

const Process = (props) => {

  const [processFormOpen, setProcessFormOpen] = useState(false);
  const [editProcessForm, setEditProcessForm] = useState();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [error, setError] = useState("");
  const [isError, setIsError] = useState(false);
  const [confirmModel, setConfirmModel] = useState(false);
  const [selectedItem, setSelectedItem] = useState([]);
  const [processValue, setProcessvalues] = useState([]);
  const [isAlert, setIsAlert] = useState(false);

  // const [sizeCode, setSizeCode] = useState(props.sizeCode);

  let processList = useSelector(
    (state) =>
      state?.masterList?.page[Constants.MASTER.PROCESS.name]?.data[0]?.process
  ); // User Details from Store
  useEffect(() => {
    setProcessvalues(processList);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [processList]);

  // const handleProcessClose = () => {
  //   setProcessOpen(false);
  // };
  const handleProcessOpen = (data) => {
    if (data) {
      setEditProcessForm(data);
    }
    setProcessFormOpen(true);
  };

  const handleProcessFormClose = () => {
    setProcessFormOpen(false);
  };
  const handleRowSelected = ({ selectedRows }) => {
    const selectChecklists = selectedRows.map((item) => item.deptCode);
    setSelectedItem([...selectChecklists]);
  };

  const resetAlert = () => {
    setIsAlert(false);
  };
  const resetError = () => {
    setIsError(false);
    setError("");
  };
  const confirmBeforeDelete = (data, singleDelete = false) => {
    if (singleDelete) {
      setSelectedItem([data.deptCode]);
      setConfirmModel(true);
    } else {
      if (selectedItem.length === 0) {
        setIsAlert(true);
        return
      } else {
        setConfirmModel(true);
      }
    }
  };

  const handleProcessSave = (data, edit) => {
    let param = {};
    param.method = Constants.MASTER.PROCESS.UPDATE;
    param.process = (processValue ?? []).concat(data);
    param.sizeCode = props?.sizeCode;
    param.sizeName = props?.sizeName;
    param.edit = edit;

    dispatch(addMasterRecord(param)).then((res) => {
      if (res?.payload?.status === 200) {
        toastFunc(
          Constants.MASTER.TOAST.success,
          t("msg_master_list.msg_process.success_message"),
          2000
        );
        let param = {};
        param.url = "getProcessMasterListDataById";
        param.page = Constants.MASTER.PROCESS.name;
        param.id = props.sizeCode;

        dispatch(fetchMasterListById(param));
        setProcessFormOpen(false);
      } else {
        setError(
          res?.payload?.message ||
            "Unable to update the process. Please try again."
        );
        setIsError(true);
      }
    });
  };

  const handleDelete = () => {
    const filteredData = processValue.filter(
      (item) => !selectedItem.includes(item.deptCode)
    );
    const updatedData = filteredData.map((item, index) => ({
      ...item,
      processOrder: parseInt(index + 1), // Assign new processOrder starting from 1
    }));

    let param = {};
    param.method = Constants.MASTER.PROCESS.UPDATE;
    param.process = updatedData;
    param.sizeCode = props?.sizeCode;
    param.sizeName = props?.sizeName;
    param.edit = false;

    dispatch(addMasterRecord(param)).then((res) => {
      if (res?.payload?.status === 200) {
        toastFunc(
          Constants.MASTER.TOAST.success,
          t("msg_master_list.msg_process.delete_success_message"),
          2000
        );
        let param = {};
        param.url = "getProcessMasterListDataById";
        param.page = Constants.MASTER.PROCESS.name;
        param.id = props.sizeCode;

        dispatch(fetchMasterListById(param));

        setSelectedItem([]);
        setConfirmModel(false);
      } else {
        setError(
          res?.payload?.message ||
            "Unable to delete the process. Please try again."
        );
        setIsError(true);
      }
    });
  };

  const columnsData = [
    {
      name: t("msg_common.actions"),
      cell: (row) => (
        <>
          {/* <span>
            <i
              className="bi bi-pencil-square iconTable"
              // onClick={() => handleOpen(row)}
            ></i>
          </span> */}
          <span>
            <i
              className="bi bi-trash3 iconTable"
              onClick={() => confirmBeforeDelete(row, true)}
            ></i>
          </span>
        </>
      ),
      width: "120px",
    },
    {
      name: "Order",
      selector: (row) => row.processOrder,
      sortable: true,
      width: "120px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-datatable-row">{row.processOrder} </p>
        </div>
      ),
    },
    {
      name: "Department Code",
      selector: (row) => row.deptCode,
      sortable: true,
      width: "250px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-datatable-row">{row.deptCode} </p>
        </div>
      ),
    },
    {
      name: "Department Name",
      selector: (row) => row.deptName,
      sortable: true,
      width: "250px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-datatable-row">{row.deptName} </p>
        </div>
      ),
    },
    {
      name: t("msg_master_list.msg_process.cycle_time")+' (mm)',
      selector: (row) => row.cycleTime,
      sortable: true,
      width: "170px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-datatable-row">{row.cycleTime} </p>
        </div>
      ),
    },
  ];

  const { onHide } = props;
  return (
    <>
      <Modal
        {...props}
        dialogClassName="modal-50w"
        onHide={onHide}
        animation={false}
      >
        <ModalHeader
          title={` ${t("msg_master_list.msg_process.process_details")} - ${props.sizeCode
            } `}
        ></ModalHeader>
        <ModalBody>
          <MasterList
            columnsData={columnsData}
            rowsData={processValue}
            paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
            pagination
            selectableRows
            // handleProcessClose
            cardHeader={true}
            handleOpen={handleProcessOpen}
            handleDelete={confirmBeforeDelete}
            handleRowSelected={handleRowSelected}
          />
        </ModalBody>
      </Modal>

      {processFormOpen && (
        <ProcessModal
          data={editProcessForm}
          sizeCode={props?.sizeCode}
          rowData={processValue}
          show={processFormOpen}
          onHide={handleProcessFormClose}
          onSave={handleProcessSave}
        ></ProcessModal>
      )}
      {confirmModel && (
        <ConfirmationModal
          show={confirmModel}
          heading={t("msg_master_list.msg_process.delete_confirm_heading")}
          bodyMessage={t("msg_master_list.msg_process.delete_confirm_body")}
          onDelete={() => handleDelete()}
          onHide={() => setConfirmModel(false)}
          type={"delete"}
        ></ConfirmationModal>
      )}
      {isError && (
        <ErrorModal
          show={isError}
          heading={t("msg_master_list.msg_process.process_error_heading")}
          bodyMessage={error}
          onHide={() => {
            resetError();
          }}
        ></ErrorModal>
      )}
      {isAlert && (
        <AlertModal
          show={isAlert}
          heading={t("msg_common.alert")}
          bodyMessage={t("msg_common.selectRecord")}
          onHide={() => {
            resetAlert();
          }}
        ></AlertModal>
      )}
    </>
  );
};

export default Process;
